import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
} from '@mui/material';

const TakedownConfirmationModal = ({ open, onClose, onConfirm, platforms, data }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Confirm Takedown</DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>
                    Are you sure you want to takedown from all these platforms?
                </Typography>
                <List dense>
                    {data.platform?.map((platformId, index) => {
                        const matchedPlatform = platforms?.find(p => p.platformId === platformId);
                        return (
                            matchedPlatform?.platform_key == "Active" ? <ListItem key={index}>
                                <ListItemText primary={matchedPlatform?.platformName || ""} />
                            </ListItem> : null
                        );
                    })}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} className='gn-actionbtn-outline gn-actionbtn-color ' variant="outlined">
                    Cancel
                </Button>
                <Button onClick={onConfirm} className='gn-actionbtn' variant="contained" >
                    Confirm Takedown
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TakedownConfirmationModal;
